import React from "react";

interface Props {
  name: string;
}

const PortfolioName = (props: Props) => {
  const { name } = props;
  return <h3 style={{ margin: 0 }}>{name}</h3>;
};

export default React.memo(PortfolioName);
